import { formatDate } from '@angular/common';
import { EventEmitter } from '@angular/core';
import { INVALID_TITLE_CHARACTERS_ERROR, INVALID_TITLE_CHARS, } from 'Angular/features/components/pdf-title-modal/pdf-title-modal.constants';
import { STRESS_TEST_DATE_RANGE_ERROR, STRESS_TEST_MISSING_TITLE_ERROR } from 'StressTestsApp/ts/constants/constants';
import { StressTestService } from 'StressTestsApp/ts/services/stress-test-service';
import * as i0 from "@angular/core";
import * as i1 from "StressTestsApp/ts/services/stress-test-service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../ycharts/static/ts/features/components/date-controls/date-range/date-range.component";
import * as i4 from "../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i5 from "@angular/forms";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i7 from "../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
const _c0 = a0 => ({ "is-invalid": a0 });
function StressTestEditModalComponent_ycn_date_range_17_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-date-range", 20);
    i0.ɵɵlistener("startDateChangeHandler", function StressTestEditModalComponent_ycn_date_range_17_Template_ycn_date_range_startDateChangeHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.changeDateSelection($event)); })("endDateChangeHandler", function StressTestEditModalComponent_ycn_date_range_17_Template_ycn_date_range_endDateChangeHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.changeDateSelection($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("startYear", 1890)("endYear", ctx_r1.dateRangeEndYear)("selectedDateRange", ctx_r1.selectedDateRange);
} }
function StressTestEditModalComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 21);
} if (rf & 2) {
    const error_r3 = ctx.$implicit;
    i0.ɵɵproperty("textContent", error_r3);
} }
function StressTestEditModalComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelement(1, "div", 23);
    i0.ɵɵelementEnd();
} }
export class StressTestEditModalComponent {
    resetAll() {
        this.state = {
            editedTitle: '',
            startDate: null,
            endDate: null,
        };
        this.selectedDateRange = { startDate: null, endDate: null };
        this.errorMessages = {
            response: null,
            dateRange: null,
            titleChars: null,
            titleEmpty: null,
        };
        this.canSubmit = false;
    }
    constructor(stressTestService) {
        this.stressTestService = stressTestService;
        this.saveAfterSubmit = false;
        this.submitModalHandler = new EventEmitter();
        this.isOpen = false;
        this.title = 'Add Stress Test';
        this.errorMessages = {};
        this.dateRangeEndYear = new Date().getFullYear();
        this.state = {
            editedTitle: '',
            startDate: null,
            endDate: null,
        };
        this.selectedDateRange = { startDate: null, endDate: null };
        this.canSubmit = false;
    }
    changeDateSelection(newDateRangeObj) {
        this.state.startDate = newDateRangeObj.startDate;
        this.state.endDate = newDateRangeObj.endDate;
        this.validateDateRange();
    }
    setCanSubmit() {
        if (this.stressTest) {
            const startDate = formatDate(this.state.startDate, 'MM-dd-yyyy', 'en-US', 'UTC');
            const endDate = this.state.endDate
                ? formatDate(this.state.endDate, 'MM-dd-yyyy', 'en-US', 'UTC')
                : null;
            this.canSubmit =
                (this.state.editedTitle !== this.stressTest.name ||
                    startDate !== this.stressTest.start_date ||
                    endDate !== this.stressTest.end_date) &&
                    !!this.state.editedTitle &&
                    !!this.state.startDate;
        }
        else {
            this.canSubmit = !!this.state.editedTitle && !!this.state.startDate;
        }
    }
    validateTitle() {
        this.errorMessages.response = null;
        this.errorMessages.titleChars = null;
        this.errorMessages.titleEmpty = null;
        if (!this.state.editedTitle) {
            this.errorMessages.titleEmpty = STRESS_TEST_MISSING_TITLE_ERROR;
            return false;
        }
        if (Array.from(this.state.editedTitle).some((char) => INVALID_TITLE_CHARS.has(char))) {
            this.errorMessages.titleChars = INVALID_TITLE_CHARACTERS_ERROR;
            return false;
        }
        this.setCanSubmit();
        return true;
    }
    validateDateRange() {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        if (!this.state.startDate ||
            this.state.startDate > yesterday ||
            (this.state.endDate && this.state.endDate <= this.state.startDate) ||
            !this.areDatesGreaterThan5DaysApart(this.state.startDate, this.state.endDate ? this.state.endDate : yesterday)) {
            this.errorMessages.dateRange = STRESS_TEST_DATE_RANGE_ERROR;
            return false;
        }
        this.errorMessages.dateRange = null;
        this.setCanSubmit();
        return true;
    }
    areDatesGreaterThan5DaysApart(date1, date2) {
        const millisecondsPerDay = 24 * 60 * 60 * 1000;
        const timeDifference = date2.getTime() - date1.getTime();
        const daysDifference = timeDifference / millisecondsPerDay;
        return daysDifference >= 5;
    }
    errorMessagesAsArray() {
        const messageArray = Array.from(Object.values(this.errorMessages));
        return messageArray.filter((error) => error != null);
    }
    submit() {
        if (this.validateTitle() && this.validateDateRange()) {
            const endDate = this.state.endDate
                ? formatDate(this.state.endDate, 'MM-dd-yyyy', 'en-US', 'UTC')
                : null;
            const startDate = formatDate(this.state.startDate, 'MM-dd-yyyy', 'en-US', 'UTC');
            if (this.saveAfterSubmit) {
                this.submitModalHandler.emit({
                    id: this.stressTest?.id,
                    order: this.stressTest?.order,
                    name: this.state.editedTitle,
                    start_date: startDate,
                    end_date: endDate,
                });
                this.closeModal();
                return;
            }
            this.loading = true;
            if (this.stressTest) {
                this.updateStressTest(this.stressTest.id, this.stressTest.order, this.state.editedTitle, startDate, endDate);
            }
            else {
                this.createStressTest(this.state.editedTitle, startDate, endDate);
            }
        }
    }
    createStressTest(name, startDate, endDate) {
        this.stressTestService
            .createStressTests({
            stress_tests: [
                {
                    name,
                    start_date: startDate,
                    end_date: endDate,
                },
            ],
        })
            .subscribe({
            next: (serializedStressTests) => {
                this.submitModalHandler.emit(serializedStressTests[0]);
                this.closeModal();
                this.loading = false;
            },
            error: (error) => {
                this.errorMessages.response = error.error;
                this.loading = false;
            },
        });
    }
    updateStressTest(id, order, name, startDate, endDate) {
        this.stressTestService
            .updateStressTest({
            id,
            order,
            name,
            start_date: startDate,
            end_date: endDate,
        })
            .subscribe({
            next: (serializedStressTest) => {
                this.submitModalHandler.emit(serializedStressTest);
                this.closeModal();
                this.loading = false;
            },
            error: (error) => {
                this.errorMessages.response = error.error;
                this.loading = false;
            },
        });
    }
    closeModal() {
        this.isOpen = false;
    }
    openModal() {
        this.resetAll();
        if (this.stressTest) {
            this.state.editedTitle = this.stressTest.name;
            this.selectedDateRange = {
                startDate: new Date(this.stressTest.start_date),
                endDate: this.stressTest.end_date ? new Date(this.stressTest.end_date) : null,
            };
            this.state.startDate = new Date(this.stressTest.start_date);
            this.state.endDate = this.stressTest.end_date ? new Date(this.stressTest.end_date) : null;
        }
        this.title = `${this.stressTest ? 'Edit' : 'Add'} Stress Test`;
        this.isOpen = true;
    }
}
StressTestEditModalComponent.ɵfac = function StressTestEditModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || StressTestEditModalComponent)(i0.ɵɵdirectiveInject(i1.StressTestService)); };
StressTestEditModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: StressTestEditModalComponent, selectors: [["ycn-stress-test-edit-modal"]], inputs: { stressTest: "stressTest", saveAfterSubmit: "saveAfterSubmit" }, outputs: { submitModalHandler: "submitModalHandler" }, standalone: false, decls: 26, vars: 13, consts: [[3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "form-row", "row"], [1, "col-3", "form-inline"], [1, "form-label"], [1, "col-9"], [1, "field-input-group", "input-group"], ["data-test-id", "title-input", 1, "form-control", "field-input", 3, "ngModelChange", "placeholder", "ngModel", "ngClass"], [1, "col-5"], [1, "data-range-cover", "form-inline", "input-group"], ["class", "inputs-wrap", 3, "startYear", "endYear", "selectedDateRange", "startDateChangeHandler", "endDateChangeHandler", 4, "ngIf"], [1, "modal-footer", "user-select-none"], [1, "popupFooter"], ["class", "feedback feedback-invalid", "data-test-id", "errors", 3, "textContent", 4, "ngFor", "ngForOf"], [1, "modal-footer-actions"], ["type", "button", 1, "btn", "btn-text", 3, "click", "textContent"], ["type", "button", "ycnDisabled", "", 1, "btn", "btn-primary", 3, "click", "disabled"], ["class", "mr-1", 4, "ngIf"], [1, "inputs-wrap", 3, "startDateChangeHandler", "endDateChangeHandler", "startYear", "endYear", "selectedDateRange"], ["data-test-id", "errors", 1, "feedback", "feedback-invalid", 3, "textContent"], [1, "mr-1"], [1, "loader-spinner-context", "loader-xs", "white"]], template: function StressTestEditModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function StressTestEditModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function StressTestEditModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6);
        i0.ɵɵtext(7, "Stress Test Title");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 7)(9, "div", 8)(10, "input", 9);
        i0.ɵɵtwoWayListener("ngModelChange", function StressTestEditModalComponent_Template_input_ngModelChange_10_listener($event) { i0.ɵɵtwoWayBindingSet(ctx.state.editedTitle, $event) || (ctx.state.editedTitle = $event); return $event; });
        i0.ɵɵlistener("ngModelChange", function StressTestEditModalComponent_Template_input_ngModelChange_10_listener() { return ctx.validateTitle(); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(11, "div", 4)(12, "div", 5)(13, "div", 6);
        i0.ɵɵtext(14, "Time Frame");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(15, "div", 10)(16, "div", 11);
        i0.ɵɵtemplate(17, StressTestEditModalComponent_ycn_date_range_17_Template, 1, 3, "ycn-date-range", 12);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(18, "div", 13)(19, "div", 14);
        i0.ɵɵtemplate(20, StressTestEditModalComponent_div_20_Template, 1, 1, "div", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 16)(22, "div", 17);
        i0.ɵɵlistener("click", function StressTestEditModalComponent_Template_div_click_22_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "div", 18);
        i0.ɵɵlistener("click", function StressTestEditModalComponent_Template_div_click_23_listener() { return ctx.submit(); });
        i0.ɵɵtemplate(24, StressTestEditModalComponent_div_24_Template, 2, 0, "div", 19);
        i0.ɵɵtext(25);
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.title);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("placeholder", "Title");
        i0.ɵɵtwoWayProperty("ngModel", ctx.state.editedTitle);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0, ctx.errorMessages.titleChars || ctx.errorMessages.titleEmpty));
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngIf", ctx.isOpen);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.errorMessagesAsArray());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("textContent", "Cancel");
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", !ctx.canSubmit);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
    } }, dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.DateRangeComponent, i4.DisabledDirective, i5.DefaultValueAccessor, i5.NgControlStatus, i5.NgModel, i6.ModalBaseComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
